import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Index from '@/views/Index.vue'
import LocalStorageService from "@/common/LocalStorageService";

const localStorageService = LocalStorageService.getService();

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      meta: {
        requiresAuth: false
      },
      component: Index
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        requiresAuth: true
      },
      component: Home
    },
    {
      path: '/timeout',
      name: 'timeout',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/Timeout.vue')
    },

    {
      path: "/request",
      name: 'request',
      meta: {
        requiresAuth: true,
        anyRole: true
      },
      component: () => import(/* webpackChunkName: "request" */ './views/EditRequest.vue')
    },

    {
      path: "/request/draft/:draftId",
      name: 'requestDraft',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-requester']
      },
      component: () => import(/* webpackChunkName: "request" */ './views/EditRequest.vue')
    },

    {
      path: "/view/:id",
      name: 'view',
      meta: {
        requiresAuth: true,
        anyRole: true
      },
      component: () => import(/* webpackChunkName: "request" */ './views/ViewRequest.vue')
    },
    {
      path: "/manager/view/:id/:o?",
      name: 'manager-view',
      meta: {
        requiresAuth: true,
        anyRole: true
      },
      component: () => import(/* webpackChunkName: "request" */ './views/ManagerGenericView.vue')
    },
    {
      path: "/specialist/view/:id/:o?",
      name: 'specialist-view',
      meta: {
        requiresAuth: true,
        anyRole: true
      },
      component: () => import(/* webpackChunkName: "request" */ './views/ManagerGenericView.vue')
    },
    {
      path: "/view/:id/:action?",
      name: 'viewPayroll',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-payroll']
      },
      component: () => import(/* webpackChunkName: "request" */ './views/ViewRequest.vue')
    },

    {
      path: "/dashboard",
      name: 'dashboard',
      meta: {
        requiresAuth: true,
        anyRole: true
      },
      component: () => import(/* webpackChunkName: "dashboard" */ './views/Dashboard.vue')
    },

    {
      path: "/workprogressmonitor",
      name: 'workprogressmonitor',
      meta: {
        requiresAuth: true,
        anyRole: true
      },
      component: () => import(/* webpackChunkName: "reports" */ './views/WorkingProgressMonitor.vue')
    },

    {
      path: "/salary",
      name: 'salaryrecommendation',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-admin', 'hrm-specialist']
      },
      component: () => import(/* webpackChunkName: "reports" */ './views/SalaryReport.vue')
    },

    {
      path: "/bureau",
      name: 'bureau',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/ManageBureaus.vue')
    },

    {
      path: "/requeststatus",
      name: 'requeststatus',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-admin','hrm-lead']
      },
      component: () => import(/* webpackChunkName: "requeststatus" */ './views/ManagePositionRequestStatus.vue')
    },

    {
      path: "/managestatus",
      name: 'managestatus',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-admin']
      },
      component: () => import(/* webpackChunkName: "requeststatus" */ './views/ManageRequestStatuses.vue')
    },

    {
      path: "/requesttype",
      name: 'requesttype',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-admin']
      },
      component: () => import(/* webpackChunkName: "requesttype" */ './views/ManageRequestTypes.vue')
    },
    
    {
      path: "/specialist",
        name: 'specialist',
        meta: {
          requiresAuth: true,
          authRoles: ['hrm-admin']
    },
      component: () => import(/* webpackChunkName: "admin" */ './views/ManageSpecialists.vue')
    },

    {
      path: "/division",
        name: 'division',
        meta: {
          requiresAuth: true,
          authRoles: ['hrm-admin']
    },
      component: () => import(/* webpackChunkName: "admin" */ './views/ManageDivisions.vue')
    },

    {
      path: "/assignment/staffing",
        name: 'staffingAssignment',
        meta: {
          requiresAuth: true,
          authRoles: ['hrm-admin','hrm-lead']
    },
      component: () => import(/* webpackChunkName: "admin" */ './views/ManageStaffingAssignments.vue')
    },

    {
      path: "/assignment/payroll",
        name: 'payrollAssignment',
        meta: {
          requiresAuth: true,
          authRoles: ['hrm-admin','hrm-lead']
    },
      component: () => import(/* webpackChunkName: "admin" */ './views/ManagePayrollAssignments.vue')
    },

    {
      path: "/checklist",
        name: 'checklist',
        meta: {
          requiresAuth: true,
          authRoles: ['hrm-admin']
    },
      component: () => import(/* webpackChunkName: "admin" */ './views/ManageCheckList.vue')
    },

    {
      path: "/standardcomment",
        name: 'standardcomment',
        meta: {
          requiresAuth: true,
          authRoles: ['hrm-admin']
    },
      component: () => import(/* webpackChunkName: "admin" */ './views/ManageStandardComments.vue')
    },

    {
      path: "/approvedLeaveRequests",
        name: 'approvedLeaveRequests',
        meta: {
          requiresAuth: true,
          authRoles: ['hrm-admin','hasLeaveRole']
    },
      component: () => import(/* webpackChunkName: "reports" */ './views/LeaveRequestApproved.vue')
    },

    {
      path: "/newLeaveRequests",
        name: 'newLeaveRequests',
        meta: {
          requiresAuth: true,
          authRoles: ['hrm-admin','hasLeaveRole']
    },
      component: () => import(/* webpackChunkName: "reports" */ './views/LeaveRequestNew.vue')
    },

    {
      path: "/activePayrollRequests",
        name: 'activePayrollRequests',
        meta: {
          requiresAuth: true,
          authRoles: ['hrm-admin','hrm-payroll']
    },
      component: () => import(/* webpackChunkName: "reports" */ './views/PayrollRequestActive.vue')
    },

    {
      path: "/completedPayrollRequests",
        name: 'completedPayrollRequests',
        meta: {
          requiresAuth: true,
          authRoles: ['hrm-admin','hrm-payroll']
    },
      component: () => import(/* webpackChunkName: "reports" */ './views/PayrollRequestCompleted.vue')
    },

    {
      path: "/closedLeaveRequests",
        name: 'closedLeaveRequests',
        meta: {
          requiresAuth: true,
          authRoles: ['hrm-admin','hasLeaveRole']
    },
      component: () => import(/* webpackChunkName: "reports" */ './views/LeaveRequestClosed.vue')
    },

    {
      path: "/settings",
        name: 'settings',
        meta: {
          requiresAuth: true,
          authRoles: ['hrm-admin','hrm-cwd']
    },
      component: () => import(/* webpackChunkName: "admin" */ './views/ManageSettings.vue')
    },

    {
      path: "/admin/bulk",
          name: 'admin-bulk',
          meta: {
            requiresAuth: true,
            authRoles: ['hrm-admin']
          },
          component: () => import(/* webpackChunkName: "admin" */ './views/BatchApproval.vue')
    },

    {
      path: "/approvers",
          name: 'approvers',
          meta: {
            requiresAuth: true,
            authRoles: ['hrm-admin']
          },
          component: () => import(/* webpackChunkName: "admin" */ './views/ManageApprovers.vue')
    },

    {
      path: "/attachments",
      name: 'attachments',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/ManageAttachments.vue')
    },

     
    {
      path: "/search",
        name: 'search',
        meta: {
          requiresAuth: true,
          anyRole: true
    },
      component: () => import(/* webpackChunkName: "admin" */ './views/Search.vue')
    },

    {
      path: "/tracking-search",
      name: 'tracking-search',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/TrackingSearch.vue')
    },

    {
      path: "/admin/edit/:id",
      name: 'admin-edit',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/AdminEdit.vue')
    },

    {
      path: "/leaveSearch",
      name: 'leaveSearch',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-admin','hasLeaveRole']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/LeaveSearch.vue')
    },

    {
      path: "/reports",
      name: 'reports',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/HRMReports.vue')
    },

    {
      path: "/separation/:id?",
      name: 'separation',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-transactions']
      },
      component: () => import(/* webpackChunkName: "request" */ './views/EditSeparationRequest.vue')
    },

    {
      path: "/requestRoleSearch",
      name: 'requestRoleSearch',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-user-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/user-management/RequestRoleSearch.vue')
    },

    {
      path: "/userSearch",
      name: 'userRoleSearch',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-user-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/user-management/UserSearch.vue')
    },

    {
      path: "/manageRole",
      name: 'manageRole',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-user-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/user-management/ManageRole.vue')
    },

    {
      path: '/requestRole',
      name: 'requestRole',
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "access" */ './views/user-management/RequestRole.vue')
    },

    {
      path: "/loadRequesters",
      name: 'loadRequesters',
      meta: {
        requiresAuth: true,
        authRoles: ['hrm-user-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/load/LoadRequesters.vue')
    },

    {
      path: '/unauthorized',
      name: 'unauthorized',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "unauthorized" */ './views/Unauthorized.vue')
    },

    {
      path: '*', 
      component: Home
    }
  ]
})

router.beforeEach(async(to, from, next) => {
  await Vue.nextTick()
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (router.app.$keycloak && router.app.$keycloak.authenticated) {
      if (to.meta.authRoles) {
        let hasRole = false
        for (var i = 0; i < to.meta.authRoles.length; i++) {
          if (router.app.$keycloak.hasResourceRole(to.meta.authRoles[i])) {
            hasRole = true;
          }
        }
        if (hasRole) {
          next()
        } else {
          router.push('unauthorized') 
        }
      } else if (to.meta.anyRole) {
        if (router.app.$keycloak.hasAnyRole) {
          next()
        } else {
          router.push('unauthorized')
        }
      } else {
        next();
      }
    } else {
      const url = localStorageService.getLoginUrl()
      window.location.replace(url)
    }
  } else {
    next()
  }
})

export default router